import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';
import Login from 'components/pages/Login';
import LoginCallback from 'components/pages/LoginCallback';
import Error from 'components/pages/Error';
import Logout from 'components/pages/Logout';
import PrivateRoutesWrapper from 'components/core/PrivateRoutesWrapper';
import { renderNestedLayoutRoutes } from 'utils/routes';
import layoutRoutes from './layoutRoutes';

const AppRoutes = (props) => {
  const {
    isAuthenticated,
    hasAcceptedTC,
    userId,
    checkLogin,
    getFeatureFlags,
  } = props;

  useEffect(() => {
    (async () => {
      try {
        await Promise.all([getFeatureFlags()]);
      } catch (e) {
        console.warn(e);
      }
    })();
  }, [getFeatureFlags]);

  return (
    <Switch>
      {/*Public routes*/}
      <Route exact path={'/Login'}>
        <Login />
      </Route>
      <Route exact path={'/LoginCallback'}>
        <LoginCallback />
      </Route>
      <Route exact path={'/ErrorPage'}>
        <Error />
      </Route>
      <Route exact path={'/Logout'}>
        <Logout />
      </Route>
      {/* Private routes with layout*/}
      <Route>
        <PrivateRoutesWrapper
          checkLogin={checkLogin}
          isAuthenticated={isAuthenticated}
          hasAcceptedTC={hasAcceptedTC}
          userId={userId}>
          {renderNestedLayoutRoutes(layoutRoutes)}
        </PrivateRoutesWrapper>
      </Route>
    </Switch>
  );
};

AppRoutes.propTypes = {
  isAuthenticated: PropTypes.bool,
  hasAcceptedTC: PropTypes.bool,
  userId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  checkLogin: PropTypes.func.isRequired,
};

AppRoutes.defaultProps = {
  isAuthenticated: false,
  hasAcceptedTC: true,
  userId: null,
};

export default AppRoutes;
